import React from 'react'
import { NavLink } from 'react-router-dom'

import './styles.scss'

type BaseProps = {
  children: React.ReactNode
  icon?: any
}

type ToProps = BaseProps & {
  to: string
  onClick?: never
}

type ClickProps = BaseProps & {
  onClick: () => void
  to?: never
}

type Props = ToProps | ClickProps

const SideNavLink: React.FC<Props> = ({ icon, children, ...rest }) => {
  const content = (
    <>
      {icon ? React.cloneElement(icon, { width: 23, height: 23 }) : null}
      {children}
    </>
  )

  if ('to' in rest && rest.to != null) {
    return (
      <NavLink to={rest.to} className='side-nav-link'>
        {content}
      </NavLink>
    )
  }

  return (
    <button type='button' className='side-nav-link' onClick={rest.onClick}>
      {content}
    </button>
  )
}

export default SideNavLink
